import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.login(form);
      // Clear old data first
      localStorage.clear();
      login(res.data, res.data.token);
      if (res.data.role === 'admin') navigate('/admin');
      else if (res.data.role === 'provider') navigate('/provider');
      else navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-brand">
          <div className="auth-logo">SS</div>
          <h2>SmartService</h2>
        </div>
        <h1>Welcome Back!</h1>
        <p>Login to book services, manage your bookings, and connect with trusted professionals.</p>
        <div className="auth-features">
          <div className="auth-feature">✅ 500+ Verified Providers</div>
          <div className="auth-feature">✅ Secure Booking System</div>
          <div className="auth-feature">✅ 24/7 Customer Support</div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-form-box">
          <h2>Login to your account</h2>
          <p className="auth-sub">Enter your credentials below</p>

          {error && <div className="auth-error">⚠️ {error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="your@email.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
            </div>

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="auth-divider">
            <span></span>
          </div>

      <p className="auth-switch">
            Don't have an account? <Link to="/register">Sign up free</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
